var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.85,
    height: 11.07,
    style: {
      display: "inline-block",
      marginRight: 5,
      marginBottom: 2
    },
    viewBox: "0 0 10.086 12.607"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.043 6.934a.63.63 0 0 0-.63.63v1.891a.63.63 0 0 0 1.261 0V7.564a.63.63 0 0 0-.631-.63m3.152-2.521V3.152a3.152 3.152 0 0 0-6.3 0v1.261A1.89 1.89 0 0 0 0 6.3v4.413a1.89 1.89 0 0 0 1.891 1.891h6.3a1.89 1.89 0 0 0 1.891-1.891V6.3a1.89 1.89 0 0 0-1.887-1.887M3.152 3.152a1.891 1.891 0 1 1 3.782 0v1.261H3.152Zm5.673 7.564a.63.63 0 0 1-.63.63h-6.3a.63.63 0 0 1-.63-.63V6.3a.63.63 0 0 1 .63-.63h6.3a.63.63 0 0 1 .63.63Z"
  })));
};
export default SvgLock;